export const prop = (type, _default = type()) => ({
  type,
  default: _default,
});

export const propRequired = type => ({
  type,
  required: true,
});
